import { BaseRouteService } from 'core/services';

class ProductUpcRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'product-upcs/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}
}
export default ProductUpcRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/ProductUpcRouteService.js